export default "../css/eb1843c96d8b2542b446f27607274486.ttf";